module.exports = __webpack_public_path__ + "img/icon_comment_arrow.b0d92917.svg";